export function sortByFields<T>(getFields: (target: T) => Array<number | string>) {
  return (a: T, b: T): number => {
    if (getFields.length === 0) {
      return 0;
    }
    const fieldsA = getFields(a);
    const fieldsB = getFields(b);
    for (let i = 0; i < fieldsA.length; i++) {
      if (fieldsA[i] < fieldsB[i]) {
        return -1;
      } else if (fieldsA[i] > fieldsB[i]) {
        return 1;
      }
    }
    return 0;
  }
}

export const compareNumber = (a: number | null, b: number | null) => {
  a = a == null ? -1 : a;
  b = b == null ? -1 : b;
  return a - b;
}

export const isArrayContentIdentical = (arr1: any[], arr2: any[]) => {
  if (Array.isArray(arr1) && Array.isArray(arr2)) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    return JSON.stringify(arr1.sort()) === JSON.stringify(arr2.sort());
  }

  return false;
}
